import React, { useRef } from "react";
import { Button, Input, DatePicker, Image, Modal, InputNumber, Checkbox, Tag, Radio } from "antd";
import { AiOutlineInbox } from "react-icons/ai";
import { BsHouseDoor, FaBoxes, FaHandHoldingUsd, IoMdArchive } from "react-icons/all";
import SpeedDial from "@material-ui/lab/SpeedDial";
import SpeedDialIcon from "@material-ui/lab/SpeedDialIcon";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
import { CloseCircleOutlined, CheckCircleOutlined, EllipsisOutlined, TagOutlined, EyeOutlined, FilterOutlined, DollarOutlined, MessageOutlined, PrinterOutlined, LoadingOutlined } from "@ant-design/icons";
import { useLink } from "./Hooks/useLink";
import fallbackimg from "../assets/fallbackimg.png";
import formatarData from "../Utils/formatarData";
import SpinnerPadrao from "./SpinnerPadrao";
import handleTabIndex from "../Utils/HandleTabIndex";
import { returnStatus } from "../Utils/utils";

export function EyeIcon(props) {
  return <EyeOutlined {...props} className="cor-primary cad-icon-small" />;
}

export function DelIcon(props) {
  return <CloseCircleOutlined  {...props} className="cor-danger cad-icon-small" />;
}

export function OkIcon(props) {
  return <CheckCircleOutlined  {...props} className="row-verde cad-icon-small" />;
}

export function ReturnIcon(props) {
  return <IoMdArchive {...props} className="row-amarelo cad-icon-small" />;
}

export function MoneyIcon(props) {
  return <DollarOutlined className="row-amarelo cad-icon-small"  {...props} />;
}

export function HouseIcon(props) {
  return <BsHouseDoor {...props} className="row-amarelo cad-icon-small" />;
}

export function TagIcon(props) {
  return <TagOutlined {...props} />;
}

export function FilterIcon(props) {
  return <FilterOutlined {...props} />;
}

export function PrestadorIcon(props) {
  return <FaHandHoldingUsd {...props} className="row-verde cad-icon" />;
}

export function BoxIcon(props) {
  return <FaBoxes {...props} />;
}

export function PrinterIcon(props) {
  return <PrinterOutlined className="row-azul cad-icon-small"   {...props} />;
}

export function ObsIcon(props) {
  return <MessageOutlined {...props} className="row-azul cad-icon-small" />;
}

export function BtnPrint(props) {
  return <PrinterOutlined className={`${props.small ? 'cad-icon-small' : 'cad-icon'} cor-primary `} title="Imprimir" {...props} />;
}

export function LoadingIcon(props) {
  return <LoadingOutlined className="cad-icon-small" {...props} />;
}

export const InputPadrao = React.forwardRef((props, ref) => {

  const keyPress = e => {
    if (e.keyCode === 13)
      handleTabIndex(props.tabIndex, props.nextTab);
  };

  return <>
    {!!props.title && <LabelPadrao noMargin={props.noMargin}>{props.title}</LabelPadrao>}
    <Input onKeyDown={keyPress} {...props} ref={ref} />
  </>;

});

export const TextAreaPadrao = React.forwardRef((props, ref) => {

  const keyPress = e => {
    if (e.keyCode === 13)
      handleTabIndex(props.tabIndex, props.nextTab);
  };

  return <Input.TextArea onKeyDown={keyPress} {...props} ref={ref} />;
});

export const InputPasswordPadrao = React.forwardRef(({ value, ...props }, ref) => {
  return <InputPadrao  {...props} type="password" ref={ref} />;
});

export function ImageDefault({ width, src, preview, ...props }) {
  return <Image {...props} width={width} src={src} preview={preview} fallback={fallbackimg} />;
}

export const InputNumberPadrao = React.forwardRef((props, ref) => {
  const inputRef = useRef(ref);
  const refPadrao = !!ref ? ref : inputRef;

  const keyPress = e => {
    if (e.keyCode === 13)
      handleTabIndex(props.tabIndex, props.nextTab);
  };

  return <InputNumber
    onKeyDown={keyPress}
    decimalSeparator=","
    {...props}
    onBlur={v => {
      if (!v.target.value && !props.nullable)
        props.onChange(props.min || 0);

      if (!!props.onBlur)
        props.onBlur(v);
    }}
    onFocus={v => {
      if (!!props.onFocus)
        props.onFocus(v);

      refPadrao.current?.select();
    }}
    ref={refPadrao} />;
});

export function DatePickerPadrao(props) {
  const keyPress = e => {
    if (e.keyCode === 13) {
      handleTabIndex(props.tabIndex, props.nextTab);
      e?.blur();
    }
  };

  return <DatePicker onKeyDown={keyPress} format={props.picker === "month" ? "MM/YYYY" : "DD/MM/YYYY"} allowClear={false} {...props} />;
}

export function RadioBtnPadrao({ options, onChange, value, ...props }) {
  return <Radio.Group optionType="button" buttonStyle="solid" options={options} onChange={v => onChange(v.target.value)} value={value} {...props} />;
}

export function TagMotivoCancelamento({ data, motivo, ...props }) {
  return <Tag color="red" style={{ ...props.style }}>
    Cancelado em {formatarData(data).DATAHORA}
    {motivo && <p style={{ marginBottom: 0 }}>{motivo}</p>}
  </Tag>;
}

export function BtnLinkFetch(props) {
  const [abrirLink, abrindoLink] = useLink(props.fetch, props.rota, props.modelo, props.dados);

  return <Button onClick={abrirLink} type="link" disabled={abrindoLink}>{props.children}</Button>;
}

export function SemDados({ text, ...props }) {
  return <div {...props} style={{ textAlign: "center", opacity: 1, userSelect: "none", ...props.style }}>
    <AiOutlineInbox style={{ color: "#ddd" }} fontSize={75} />
    <span style={{ color: "#d1d1d1", display: "block" }}>{text || "Sem Dados"}</span>
  </div>;
}

export function ModalPadrao({ visible, footer, title, onOk, onCancel, ...props }) {
  return <Modal style={{ marginTop: -80 }} destroyOnClose title={title} open={visible} footer={footer} onOk={onOk} onCancel={onCancel} {...props}>{props.children}</Modal>;
}

export function LabelPadrao(props) {
  return <p {...props} style={{ marginBottom: 0, fontWeight: "bold", color: "rgba(0, 0, 0, 0.65)", marginTop: !props.noMargin && 10, display: "block", ...props.style }}>
    {props.children}
  </p>;
}

export function CheckBoxPadrao(props) {
  return <Checkbox {...props} >{props.children}</Checkbox>;
}

export function SpeedDialPadrao({ dots, ...props }) {
  return <SpeedDial ariaLabel="SpeedDial example" open={props.open} icon={!!dots ? <EllipsisOutlined style={{ fontSize: 20 }} /> : <SpeedDialIcon />} {...props}>
    {props.ActionList.map((x, inx) => (
      <SpeedDialAction s tooltipTitle={x.title} key={inx} icon={x.icon} {...x} />
    ))}
  </SpeedDial>;
}

export function LoadingContainerPadrao({ loading, ...props }) {
  return <div style={{ position: "relative", pointerEvents: loading && "unset", userSelect: loading && "none", ...props.style }}>
    <div style={{ opacity: loading ? 0.5 : 1 }}>{props.children}</div>
    {loading && <div style={{ position: "absolute", width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: 'column', top: 0, padding: 25 }}>
      {!props.disableSpinner && <SpinnerPadrao style={{ width: 80, ...props.spinnerProps }} />}
      {!!props.loadingMsg && <LabelPadrao style={{ textAlign: 'center' }}>{props.loadingMsg}</LabelPadrao>}
    </div>}
  </div>;
}

export function LegendaEntrega({ status, onClick }) {
  const info = returnStatus(status);

  return <div onClick={() => onClick(status)} style={{ display: "flex", alignItems: "center", cursor: !!onClick ? "pointer" : "initial" }}>
    <Tag color={info.color} style={{ width: 15, height: 15 }} />
    <LabelPadrao noMargin style={{ fontSize: 13 }}>{info.title}</LabelPadrao>
  </div>;
}